module.exports = __webpack_public_path__ + "img/question-white.66995772.svg";